define('plugin/membership/model/MembershipModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Membership data model
     *
     * @class MembershipModel
     */
    return BaseModel.extend({

        defaults: {
            id: '',
            name: '',
            description: '',
            first_price: 0,
            recurring_price: 0,
            duration: 1,
            duration_type: 'month',
            is_active: 1,
            position: 0,
            file_id: null,
            is_purchased: false
        }

    });

});
